import { GET, POST, PATCH } from '../utils/restUtils';
import { Auth } from 'aws-amplify';
import _ from "lodash";

const getToken = async () => {
  let session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
}

export const getAccounts  = async (config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  let {data} = await GET("/account",config);
  console.log('service', data);
  return data
}

export const saveAccount = async (update,config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  let data = await POST("/account",update,config) 
  return data
}

export const getOneAccount = async (key,config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  let data = await GET(`/account/${key}`,config);
  return data
}

export const accountChangeStatus = async (key,update,config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  let data = PATCH(`/account/${key}/enable`, update,config)
  return data
}


export default {
  getAccounts,
  saveAccount,
  getOneAccount,
  accountChangeStatus
}



